module.exports = __webpack_public_path__ + "static/media/pieceEuro2.dcae36fa.webp";